import { useMutation } from "hooks/useQueries";
import { PartnerFormValues } from "interfaces/Partner";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { refetchQuery } from "utils/helpers";

export const usePartner = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { mutateAsync: createPartner, isLoading: partnerCreateLoading } =
    useMutation({
      mutationKey: ["CREATE_PARTNER"],
      mutationFn: (data: PartnerFormValues) =>
        axiosInstance.post("/partner/", data),
      onSuccess: () => {
        refetchQuery("FETCH_ALL_PARTNER");
      },
    });

  const { mutateAsync: updatePartner, isLoading: partnerUpdateLoading } =
    useMutation({
      mutationKey: ["UPDATE_PARTNER"],
      mutationFn: (values: PartnerFormValues) =>
        axiosInstance.patch(`/partner/${id}/`, values),
    });

  const { mutateAsync: deletePartner, isLoading: deletePartnerLoading } =
    useMutation({
      mutationFn: (id) => axiosInstance.delete(`/partner/${id}/`),
      onSuccess: () => {
        navigate(-1);
      },
    });

  const { mutateAsync: activePartner, isLoading: activePartnerLoading } =
    useMutation({
      mutationKey: ["ACTIVE_INACTIVE_PARTNER"],
      mutationFn: (values: { active: boolean }) =>
        axiosInstance.patch(`/partner/${id}/active/`, values),
      onSuccess: () => {
        refetchQuery("GET_PARTNER_ACTIVE_DETAILS");
      },
    });

  return {
    updatePartner,
    partnerUpdateLoading,
    createPartner,
    partnerCreateLoading,
    activePartner,
    activePartnerLoading,
    deletePartner,
    deletePartnerLoading,
  };
};
